import { render, staticRenderFns } from "./purchaseInvoiceActive.vue?vue&type=template&id=a0f3e044&scoped=true"
import script from "./purchaseInvoiceActive.vue?vue&type=script&lang=js"
export * from "./purchaseInvoiceActive.vue?vue&type=script&lang=js"
import style0 from "./purchaseInvoiceActive.vue?vue&type=style&index=0&id=a0f3e044&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f3e044",
  null
  
)

export default component.exports